import { combineReducers, configureStore } from '@reduxjs/toolkit'
import { persistStore } from 'redux-persist'
import { blogApi, blogSlice } from '../api/blog'
import { orderApi } from "../api/order";

export const rootReducer = combineReducers({
  [blogApi.reducerPath]: blogApi.reducer,
})

export const store = configureStore({
  reducer: {
    [blogApi.reducerPath]: blogApi.reducer,
    [orderApi.reducerPath]: orderApi.reducer,
    [blogSlice.name]: blogSlice.reducer,
  },
  middleware: (getDefaultMiddleware) => getDefaultMiddleware({
    serializableCheck: false,
  }).concat(
      blogApi.middleware,
      orderApi.middleware,
  ),
})

export const persistor = persistStore(store)

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
